import { createRoot } from "react-dom/client";
import React from 'react';
import App from './App';
import { GlobalProvider } from './context/GlobalProvider';
import ResourceEnvironment from './pages/hook/ResourceEnvironment';

import './local';
import './i18n';

import './index.scss';
import './portal.scss';
import '@ant-design/v5-patch-for-react-19';
import { ApiToken } from './pages/hook/Token';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(<React.StrictMode>
  <GlobalProvider>
    {/* <ResourceEnvironment /> */}
    {/* <ApiToken /> */}
    <App />
  </GlobalProvider>
</React.StrictMode>);